import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
export default function AdminTimekeeper() {
	useDocumentTitle("Admin Timekeeper");
	return (
		<div className="p-4">
			<h1 className="text-lg mb-6">Timekeeper</h1>
			<div className="space-y-4">
				<div className="h-10 rounded-lg bg-muted animate-pulse" />
				<div className="h-10 rounded-lg bg-muted animate-pulse" />
				<div className="h-10 rounded-lg bg-muted animate-pulse" />
			</div>
		</div>
	);
}
